import { SkeletonLoader } from '@/components/SkeletonLoader';

import { OfficeSkeleton } from './OfficeSkeleton';

export default function OfficeSearchResultSkeleton() {
  return (
    <div>
      <ul
        data-testid="office-list-skeleton"
        className="grid min-[700px]:grid-cols-2 gap-x-5 gap-y-5"
      >
        <li className="pb-5 min-[1300px]:border-b border-grey-60 last:border-none min-[1300px]:[&:nth-last-child(2)]:border-none">
          <OfficeSkeleton />
        </li>
        <li className="pb-5 min-[1300px]:border-b border-grey-60 last:border-none min-[1300px]:[&:nth-last-child(2)]:border-none">
          <OfficeSkeleton />
        </li>
      </ul>

      <SkeletonLoader className="w-1/3 h-6 rounded-full" />
    </div>
  );
}
